module.exports = __webpack_public_path__ + "img/allgemeine-struktur.65bc01ed.png";